<template>
  <div class="flex flex-col items-center justify-center py-16 text-gray-500">
    <p class="text-lg">No payment activity yet</p>
    <p class="mt-2 text-sm">
      Payment activity for memberships will appear here.
    </p>
  </div>
</template>

<script setup lang="ts"></script>
